/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { competitionCategoryDtoSchema } from "./competitionCategoryDtoSchema.ts";
import { competitionProfileDtoSchema } from "./competitionProfileDtoSchema.ts";
import { competitionSlideDtoSchema } from "./competitionSlideDtoSchema.ts";
import { z } from "zod/v4";

export const competitionSectionDtoSchema = z.object({
  get slides() {
    return z.array(competitionSlideDtoSchema).optional();
  },
  get categories() {
    return z.array(competitionCategoryDtoSchema).optional();
  },
  get profiles() {
    return z.array(competitionProfileDtoSchema).optional();
  },
});
